// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"2e4a0c24","787":"44e27730"}[chunkId] + ".chunk.js";
};